import React, { useEffect, useState } from 'react';
import Confetti from 'react-confetti';
import './CongratsModal.css';

const CongratsModal = ({ show, onClose }) => {
  const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });

  useEffect(() => {
    const handleResize = () => setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!show) return null;

  return (
    <div className="congrats-modal-overlay">
        <Confetti style={{ marginLeft: '15%' }} width={windowSize.width} height={windowSize.height} numberOfPieces={300} />
        <div className="congrats-modal">
        <div>
            <button className="close-btn" onClick={onClose}>×</button>
            <h2>🎉 Congratulations!</h2>
            <p>You’ve successfully completed the setup.</p>
            <button className="cta-btn" onClick={onClose}>Review Setup</button>
        </div>
       </div>
    </div>
  );
};
export default CongratsModal;
